import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, take} from 'rxjs';
import {environment} from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class SelicApiService {
    private http = inject(HttpClient);
    private readonly apiServiceUrl = environment.serviceApi;

    findAll(): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/selic`).pipe(take(1));
    }

    sync(): Observable<any> {
        return this.http.post(`${this.apiServiceUrl}/v1/selic/sync`, {}).pipe(take(1));
    }
}

